import { Selection, SelectionMode, Text, DetailsHeader, DetailsList, IColumn, Icon, IDetailsListStyles, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, DefaultButton, Link, DetailsListLayoutMode, IDetailsRowProps, ITextField, IPanelStyles, TooltipHost, IContextualMenuItem, ContextualMenuItemType, CheckboxVisibility, ContextualMenu, CommandBar, IButtonProps, ICommandBarStyles, ICommandBarItemProps, IIconProps, IDialogContentProps, DialogType, Dialog, DialogFooter, IModalProps, IModalStyles, IDetailsList, TooltipOverflowMode, ITooltipHostStyles } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { matchPath, RouteComponentProps, withRouter } from 'react-router-dom';
import abilityBuild from '../../shared/CASL/appAbility';

import { ProtocolloAreaDiLavoroEF_Priority, ProtocolloAreaDiLavoroEF_Priority_Label, ProtocolloAreaDiLavoroEF_State, Protocol_Type, SortEF_Direction, Visibilita_ViewMode, Visibility_Type } from '../../shared/enums';
import { IDateTimeField, IField, IProtocol, IProtocolEF, IChoiceField, INumberField, IUor, IProtocolloAreaDiLavoro, IQueryCriteriaEF, IVisibilita, IWorkspaceTableState } from '../../shared/interfaces';
import { reduxActions, RootState } from '../../store';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import pdfImage from '../../assets/images/pdf.svg';
import AppUtilities from '../../shared/Utilities/appUtilities';
import DynamicForm from '../DynamicForm/DynamicForm';
import axios, { CancelTokenSource } from 'axios';
import { subject, Unsubscribe } from "@casl/ability";
import { toastRef } from '../Layout/Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { myTheme } from '../../assets/styles/my-theme';
import areaDiLavoroService from '../../services/areaDiLavoro.service';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import protocolsService from '../../services/protocols.service';
import Visibilita from '../Protocols/Visibilita/Visibilita';
import RippleLoader from '../Loader/RippleLoader/RippleLoader';
import Utilities from '../../shared/Utilities/utilities';

const { palette } = myTheme;

const addIcon: IIconProps = { iconName: 'Add' };

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const filtriCommandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' }

}

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};


const visibilitaDialogStyles: Partial<IModalStyles> = {
    main: {
        '@media(min-width: 480px)': {
            width: '100%',
            maxWidth: 450
        }
    }
}

const visibilitaModalProps: IModalProps = {
    isBlocking: false,
    styles: visibilitaDialogStyles,
    className: "visibilita-dialog-wizard"
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    emptyColumn: {

    },
    filtriCommandBar: {
        paddingTop: '20px'
    }
});


const initialSearchFields: IField[] = [
    {
        decimals: 0,
        percentage: false,
        displayName: "Numero protocollo",
        internalName: "ProtocolEF.NumeroProtocollo",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    //{
    //    dateOnly: true,
    //    displayName: "Data Protocollo",
    //    internalName: "ProtocolEF.DataProtocollo",
    //    sharepointType: "Date",
    //    controlType: "calendar",
    //    required: false,
    //    readonly: false,
    //    disabled: false,
    //    rangeMode: true,
    //    internalValue: "",
    //    valid: false,
    //    touched: false

    //} as IDateTimeField,
    {
        displayName: "Tipo Protocollo",
        internalName: "ProtocolEF.TipoProtocollo",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: Protocol_Type.DocumentoInEntrata, text: "Documento in Entrata" },
            { key: Protocol_Type.DocumentoInUscita, text: "Documento in Uscita" },
            { key: Protocol_Type.DocumentoInterno, text: "Documento Interno" }
        ]

    } as IChoiceField,
    {
        displayName: "Priorità",
        internalName: "Priorita",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: ProtocolloAreaDiLavoroEF_Priority.Bassa, text: 'Bassa' },
            { key: ProtocolloAreaDiLavoroEF_Priority.Media, text: 'Media' },
            { key: ProtocolloAreaDiLavoroEF_Priority.Alta, text: 'Alta' }

        ]

    } as IChoiceField,
    {
        displayName: "Presa in carico",
        internalName: "UserId",
        sharepointType: "User",
        controlType: "autocompleteUser",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    },
    {
        displayName: "Oggetto Protocollo",
        internalName: "ProtocolEF.OggettoProtocollo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    }

];

const workspacePathString = "/:aooId/workspace";

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
    isMobile: state.sessionReducer.isMobile,
    workspaceTableState: state.appNavigationReducer.workspaceTableState,
    previousLocationPathName: state.appNavigationReducer.previousLocationPathName,

})
const mapDispatch = {
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
    setWorkspaceTableState: (workspaceTableState: (Partial<IWorkspaceTableState>)) => (reduxActions.appNavigationActions.setWorkspaceTableState(workspaceTableState)),
    unsetWorkspaceTableState: () => (reduxActions.appNavigationActions.unsetWorkspaceTableState()),

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AreaDiLavoroProps {

}

export interface AreaDiLavoroState {
    columns: IColumn[];
    items: (IProtocolloAreaDiLavoro | null)[];

    commandBarItems: ICommandBarItemProps[];
    filtriCommandBarItems: ICommandBarItemProps[];

    isLoadingProtocols: boolean;
    showActionsLoader: boolean

    messageBarIsVisible: boolean;
    messageBarType: MessageBarType | undefined;
    messageBarText: string;
    selectedProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined;

    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

    queryCriteria: IQueryCriteriaEF;

    searchPanelIsOpen: boolean;
    searchFormFields: IField[];

    selectedProtocolVisibilita: IVisibilita[]

    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogModalProps: IModalProps,
    confirmDialogSubmitFunction: Function

}


type Props = AreaDiLavoroProps & RouteComponentProps & PropsFromRedux

class AreaDiLavoro extends React.Component<Props, AreaDiLavoroState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    detailsListRef = React.createRef<IDetailsList>();

    cancelTokenSources = {};
    private protocolSelection: Selection;
    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection()[0] as IProtocolloAreaDiLavoro;
                this.setState({
                    selectedProtocolAreaDiLavoro: selection
                }, () => this.updateCommandBarItems());
            },
        });

        this.state = {

            columns: [
                {
                    key: 'ProtocolEF.Visibilita',
                    name: 'visibilita',
                    isIconOnly: true,
                    fieldName: 'visibilita',
                    minWidth: 16,
                    maxWidth: 16,
                },
                {
                    key: 'ProtocolEF.HasAttachments',
                    name: 'hasAttachments',
                    className: classNames.fileIconCell,
                    iconClassName: classNames.fileIconHeaderIcon,
                    iconName: 'Attach',
                    isIconOnly: true,
                    fieldName: 'hasAttachments',
                    minWidth: 16,
                    maxWidth: 16,
                },
                {
                    key: 'ProtocolEF.NumeroProtocollo',
                    name: 'Protocollo',
                    fieldName: 'NumeroProtocollo',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true,

                },
                {
                    key: 'Priorita',
                    name: 'Priorità',
                    fieldName: 'Priorita',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true,
                },
                {
                    key: 'PresaInCarico',
                    name: 'Presa in carico',
                    fieldName: 'PresaInCarico',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true,
                },
                {
                    key: 'ProtocolEF.DataProtocollo',
                    name: 'Data protocollo',
                    fieldName: 'DataProtocollo',
                    minWidth: 110,
                    maxWidth: 110,
                    isResizable: true,
                },
                {
                    key: 'ProtocolEF.TipoProtocollo',
                    name: 'Tipo protocollo',
                    fieldName: 'TipoProtocollo',
                    minWidth: 140,
                    maxWidth: 120,
                    isResizable: true,
                },
                {
                    key: 'ProtocolEF.OggettoProtocollo',
                    name: 'Oggetto protocollo',
                    fieldName: 'Title',
                    minWidth: 110,
                    isResizable: true,
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                },

            ],
            items: [],

            commandBarItems: [],
            filtriCommandBarItems: [],

            isLoadingProtocols: true,
            showActionsLoader: false,

            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: "",
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined,

            queryCriteria: { pageNumber: 1, pageSize: 100, filters: [], sorts: [] },

            searchFormFields: [...initialSearchFields],
            searchPanelIsOpen: false,

            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogModalProps: {},
            confirmDialogSubmitFunction: () => { },

            selectedProtocolAreaDiLavoro: undefined,
            selectedProtocolVisibilita: []
        }
    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();

            if (this.props.currentAoo) {
                let { currentAoo, history, location, match } = this.props;

                const parsedQueryString = queryString.parse(location.search);
                let uorId: number = Number(parsedQueryString.uorId);
                let aooId: number = Number(match.params['aooId']);

                if (uorId === undefined || abilityBuild.cannot('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {
                    history.push({ pathname: '/notfound' });
                }
                let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
                if (abilityBuild.cannot('read', subject('IProtocolloAreaDiLavoro', prot))) {
                    this.props.history.push({ pathname: '/unauthorized' });
                }

                let storedColumns: IColumn[] = JSON.parse(localStorage.getItem(`columns_${aooId}_${uorId}`)!);

                let storedState = { ...this.props.workspaceTableState }
                if (storedState && storedState.items && storedState.items.length > 0 && storedState.uorId === uorId) {
                    this.restoreAxiosState(storedState);
                }
                else if (storedColumns && storedColumns.length > 0) {
                    this.restoreLocalStorage(storedColumns);
                }
                else if (currentAoo && uorId) {
                    this.getProtocolliAreaDiLavoro();
                }
            }
        });

    }


    componentDidUpdate(oldProps: Props, oldState: AreaDiLavoroState,) {
        if ((this.props.currentAoo && this.props.features && (this.props.currentAoo !== oldProps.currentAoo || this.props.location !== oldProps.location))) {

            let { currentAoo, history } = this.props;

            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            if (uorId === undefined || abilityBuild.cannot('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {
                history.push({ pathname: '/notfound' });
            }
            let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
            if (abilityBuild.cannot('read', subject('IProtocolloAreaDiLavoro', prot))) {
                this.props.history.push({ pathname: '/unauthorized' });
            }


            if (oldProps.currentUor !== this.props.currentUor || oldState.selectedProtocolAreaDiLavoro !== this.state.selectedProtocolAreaDiLavoro) {
                this.updateCommandBarItems();
            }

        }

    }

    componentWillUnmount() {
        this.saveState();

        this.unsubscribeFromAbility();
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }

    }

    saveState = () => {
        let startItemIndexInView = this.detailsListRef.current?.getStartItemIndexInView();
        let { commandBarItems, messageBarIsVisible, messageBarText, messageBarType, isLoadingProtocols,
            ...workspaceTableState } = this.state;
        if (!workspaceTableState.items || workspaceTableState.items.length === 0) {
            workspaceTableState.items = [null];
        }
        this.props.setWorkspaceTableState({ ...workspaceTableState, startItemIndexInView: startItemIndexInView, uorId: this.props.currentUor?.id });
    }

    restoreAxiosState = (workspaceTableState: Partial<IWorkspaceTableState>) => {

        let { history } = this.props;
        let storedState = { ...workspaceTableState }

        if (history.action === 'POP') {
            this.setState({
                columns: storedState.columns!,
                items: storedState.items!,
                queryCriteria: storedState.queryCriteria!,
                searchFormFields: storedState.searchFormFields!,
                isLoadingProtocols: false,
                showActionsLoader: false

            }, () => {
                setTimeout(() => {
                    this.detailsListRef.current?.focusIndex(storedState.startItemIndexInView ?? 0);
                    this.updateCommandBarItems();
                }, 100);
            })
        }
        else {
            let currentQueryCriteria: IQueryCriteriaEF = {
                ...storedState!.queryCriteria!,
                pageNumber: 1,
            };

            this.setState({
                columns: storedState.columns!,
                items: [],
                queryCriteria: currentQueryCriteria,
                searchFormFields: storedState.searchFormFields!,
                isLoadingProtocols: false,
                showActionsLoader: false

            }, () => {
                setTimeout(() => {
                    this.getProtocolliAreaDiLavoro();
                    this.updateCommandBarItems();
                }, 100);
            })


        }


    }
    restoreLocalStorage = (storedColumns: IColumn[]) => {
        let column: IColumn | undefined = storedColumns.find((col: IColumn) => col.isSorted);
        if (column) {
            let newIsSortedDescending = !column.isSortedDescending;
            let sortDirection = newIsSortedDescending ? SortEF_Direction.Descending : SortEF_Direction.Ascending;
            let currentQueryCriteria: IQueryCriteriaEF = {
                ...this.state.queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, sortDirection: sortDirection }]
            };

            this.setState({
                isLoadingProtocols: true,
                columns: storedColumns,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolliAreaDiLavoro();
            });
        }
    }

    updateContextMenuDashboard = (ev, protocolloEF: IProtocolEF) => {
        const { location } = this.props
        const menuItems: IContextualMenuItem[] = [];
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        let { selectedProtocolAreaDiLavoro } = this.state;

        menuItems.push(
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, protocolloEF);
                    this.onHideContextualMenu();
                }
            }
        );
        if (selectedProtocolAreaDiLavoro?.protocolEF?.hasAttachments) {

            menuItems.push(
                {
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: () => {
                        this.onDownloadAllButtonClick!();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const userOperatoreUor = this.props.currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === this.props.currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo
        if (userOperatoreUor.length > 0) {
            menuItems.push({
                key: 'createFrom',
                text: 'Crea da',
                iconProps: { iconName: 'Copy' },
                onClick: (event) => {
                    let { selectedProtocolAreaDiLavoro } = this.state;
                    let protocol = { ...selectedProtocolAreaDiLavoro!.protocolEF };
                    let protocolSPId = protocol?.protocolSpId;
                    this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/createfrom/${protocolSPId}` })
                }


            });
        }
        if (userOperatoreUor.length > 0 && userOperatoreUor.some(el => el.id === uorId)) {
            menuItems.push(
                {
                    key: 'editVisibilita',
                    text: 'Modifica visibilità',
                    iconProps: { iconName: 'RedEye' },
                    onClick: () => this.onEditVisibilitaHandler()
                },
            );
        }
        if (selectedProtocolAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.Undefined
            || selectedProtocolAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere) {
            menuItems.push(
                {
                    key: 'avviaLavorazione',
                    text: 'Avvia lavorazione',
                    iconProps: { iconName: 'Play' },
                    onClick: this.onAvviaLavorzioneClick
                },
            );

        }
        if (selectedProtocolAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.InLavorazione) {
            menuItems.push(
                {
                    key: 'priorita',
                    text: 'Priorit\u00e0',
                    iconProps: { iconName: 'Sort' },
                    subMenuProps: {
                        items: [
                            {
                                key: 'alta',
                                text: 'Alta',
                                iconProps: { iconName: 'ChevronUp' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Alta)
                            },
                            {
                                key: 'media',
                                text: 'Media',
                                iconProps: { iconName: 'Remove' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Media)
                            },
                            {
                                key: 'bassa',
                                text: 'Bassa',
                                iconProps: { iconName: 'ChevronDown' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Bassa)
                            },
                        ],
                    },
                },
            );
            menuItems.push(
                {
                    key: 'presaInCarico',
                    text: 'Presa in carico',
                    iconProps: { iconName: 'ReminderPerson' },
                    onClick: this.onPresaInCaricoClick
                },
            );
            menuItems.push(
                {
                    key: 'terminaLavorzione',
                    text: 'Termina lavorazione',
                    iconProps: { iconName: 'CheckList' },
                    onClick: this.onTerminaLavorzioneClick
                },
            );

        }

        return menuItems;
    }

    updateCommandBarItems = () => {
        const { currentUor, currentUser, currentAoo, location } = this.props
        const newCommandBarItems: ICommandBarItemProps[] = [];
        const newFiltriCommandBarItems: ICommandBarItemProps[] = [];

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };

        if (abilityBuild.can('create', subject('IProtocol', prot))) {
            newCommandBarItems.push(
                {
                    key: 'nuovoProtocollo',
                    commandBarButtonAs: () => (
                        <DefaultButton
                            primary
                            text="Nuovo"
                            iconProps={addIcon}
                            allowDisabledFocus
                            onClick={(event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/new` })}

                        />
                    )
                }

            );

        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'PecMail', enabled: true }))
            && abilityBuild.can('read', 'IMailPecMail')
            && currentUor && currentUor.mailboxesIn && currentUor.mailboxesIn.length > 0) {

            newCommandBarItems.push({
                key: 'pecmail',
                text: 'Pec & Mail',
                iconProps: { iconName: 'Mail' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/pecmail` })


            });
        }



        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('read', 'IFascicolo')
            && currentUor) {

            newCommandBarItems.push({
                key: 'fascicoli',
                text: 'Fascicoli',
                iconProps: { iconName: 'DocumentSet' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/fascicoli` })

            });
        }

        let { selectedProtocolAreaDiLavoro } = this.state;
        if (selectedProtocolAreaDiLavoro) {

            if (selectedProtocolAreaDiLavoro.protocolEF.hasAttachments) {

                newCommandBarItems.push({
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: this.onDownloadAllButtonClick
                });
            }

            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const userOperatoreUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
            // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
            // creare il protocollo

            if (userOperatoreUor.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: (event) => {
                        let { selectedProtocolAreaDiLavoro } = this.state;
                        let protocol = { ...selectedProtocolAreaDiLavoro!.protocolEF };
                        let protocolSPId = protocol?.protocolSpId;
                        this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/createfrom/${protocolSPId}` })
                    }


                });
            }
            if (userOperatoreUor.length > 0 && userOperatoreUor.some(el => el.id === uorId)) {
                newCommandBarItems.push({
                    key: 'editVisibilita',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Modifica visibilità'
                            key='editVisibilita'
                            iconPropsFontAwesome={{ icon: ['fal', 'eye'] }}
                            onClick={this.onEditVisibilitaHandler}
                        />
                    )
                });
            }
            if (selectedProtocolAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.Undefined
                || selectedProtocolAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere) {
                newCommandBarItems.push(
                    {
                        key: 'avviaLavorazione',
                        text: 'Avvia lavorazione',
                        iconProps: { iconName: 'Play' },
                        onClick: this.onAvviaLavorzioneClick
                    },
                );

            }
            if (selectedProtocolAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.InLavorazione) {
                newCommandBarItems.push(
                    {
                        key: 'priorita',
                        text: 'Priorit\u00e0',
                        iconProps: { iconName: 'Sort' },
                        subMenuProps: {
                            items: [
                                {
                                    key: 'alta',
                                    text: 'Alta',
                                    iconProps: { iconName: 'ChevronUp' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Alta)
                                },
                                {
                                    key: 'media',
                                    text: 'Media',
                                    iconProps: { iconName: 'Remove' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Media)
                                },
                                {
                                    key: 'bassa',
                                    text: 'Bassa',
                                    iconProps: { iconName: 'ChevronDown' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Bassa)
                                },
                            ],
                        },
                    },
                );
                newCommandBarItems.push(
                    {
                        key: 'presaInCarico',
                        text: 'Presa in carico',
                        iconProps: { iconName: 'ReminderPerson' },
                        onClick: this.onPresaInCaricoClick
                    },
                );
                newCommandBarItems.push(
                    {
                        key: 'terminaLavorzione',
                        text: 'Termina lavorazione',
                        iconProps: { iconName: 'CheckList' },
                        onClick: this.onTerminaLavorzioneClick
                    },
                );

            }

        }
        newFiltriCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={() => this.setState({ searchPanelIsOpen: true })}
                    />

                )
            }
        );

        if (this.state.queryCriteria.filters.length > 0) {
            newFiltriCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }

        newFiltriCommandBarItems.push(
            {
                key: 'aggiornaAreaDiLavoro',
                text: 'Aggiorna',
                iconProps: { iconName: 'Refresh' },
                onClick: () => this.onAggiornaAreaDiLavoroClick()
            },
        );




        this.setState({
            commandBarItems: newCommandBarItems,
            filtriCommandBarItems: newFiltriCommandBarItems
        });
    }

    commandBarNavigateItemHandler = (ev: any, item: any) => {
        ev.preventDefault();
        if (item !== (null || undefined) && item.url !== (null || undefined)) {
            this.props.history.push({ pathname: item.url, search: this.props.location.search });
        }
    }

    onDownloadAllButtonClick = () => {
        let { currentAoo, location } = this.props;
        const parsedQueryString = queryString.parse(location.search);
        if (currentAoo && this.state.selectedProtocolAreaDiLavoro?.protocolEF?.protocolSpId) {
            let protocolId = this.state.selectedProtocolAreaDiLavoro.protocolEF.protocolSpId;
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

            protocolsService
                .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                .then(zipFile => {
                    toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });

                    let fileBase64string = zipFile.docBase64String;
                    let fileName = zipFile.fileName;
                    if (fileBase64string && fileName) {
                        Utilities.SaveFileFromBase64(fileBase64string, fileName);
                    }
                })
                .catch(error => {

                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                    } else {
                        throw error;
                    }

                });
        };
    }

    // get protocolli area di lavoro
    getProtocolliAreaDiLavoro() {
        let { currentAoo } = this.props;
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (currentAoo && uorId) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name] = axios.CancelToken.source();

            this.setState({ isLoadingProtocols: true })
            let { queryCriteria } = this.state;

            areaDiLavoroService.getProtocolliAreaDiLavoro(uorId, queryCriteria, this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name].token)
                .then(result => {
                    let currentItems = this.state.items.slice();

                    let itemsNewPage: (IProtocolloAreaDiLavoro | null)[] = result.data;
                    let newItemsLength = currentItems.length + itemsNewPage.length;
                    if (itemsNewPage.length > 0 && newItemsLength < result.totalCount) {
                        itemsNewPage.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    this.setState({
                        messageBarIsVisible: false,
                        items: [...currentItems, ...itemsNewPage],
                        isLoadingProtocols: false
                    }, () => {
                        this.saveState();
                        this.restoreSelection();

                    });

                    delete this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile recuperare i protocolli dell'area di lavoro`,
                            life: 5000
                        });
                    }
                    this.setState({
                        items: [],
                        isLoadingProtocols: false
                    }, () => {
                        this.saveState()
                    });
                });
        }
    }

    //metodo per il render dell'header di tabella
    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }
    onColumnHeaderClick = (ev: React.MouseEvent<HTMLElement> | undefined, column: IColumn | undefined): void => {
        ev?.preventDefault();
        ev?.stopPropagation();
        const { columns, queryCriteria } = this.state;

        let { location, match } = this.props;

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number = Number(parsedQueryString.uorId);
        let aooId: number = Number(match.params['aooId']);


        if (column) {
            let newIsSortedDescending = !column.isSortedDescending;
            let newColumns = columns.map((col: IColumn) => {
                if (col.key === column.key) {
                    col.isSortedDescending = newIsSortedDescending;
                    col.isSorted = true;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = true;
                }
                return col;
            });

            let sortDirection = newIsSortedDescending ? SortEF_Direction.Descending : SortEF_Direction.Ascending;
            let currentQueryCriteria: IQueryCriteriaEF = {
                ...queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, sortDirection: sortDirection }]
            }

            this.setState({
                isLoadingProtocols: true,
                columns: newColumns,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolliAreaDiLavoro();
                localStorage.setItem(`columns_${aooId}_${uorId}`, JSON.stringify(newColumns));

            })
        }
    }


    restoreSelection = () => {
        let { selectedProtocolAreaDiLavoro } = this.state;
        if (selectedProtocolAreaDiLavoro) {
            let itemIndex = this.state.items.findIndex(el => el?.protocolEFId === this.state.selectedProtocolAreaDiLavoro?.protocolEFId);
            this.protocolSelection.selectToIndex(itemIndex, false);
        }
    }

    // Click sul button della commandbar
    onPresaInCaricoClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi prendere in carico la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onPresaInCaricoConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onPresaInCaricoConfirmDialogSubmit = () => {
        let { selectedProtocolAreaDiLavoro } = this.state
        if (selectedProtocolAreaDiLavoro) {

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });

            let removeAfterUpdate = false;

            areaDiLavoroService.pendiInCarico(selectedProtocolAreaDiLavoro)
                .then((newSelectedProtocolAreaDiLavoro) => {

                    this.updateProtocolSubmit(newSelectedProtocolAreaDiLavoro, removeAfterUpdate);

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });
        }
    }

    // Click sul button della commandbar
    onAvviaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi avviare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit = () => {
        let { selectedProtocolAreaDiLavoro } = this.state
        if (selectedProtocolAreaDiLavoro) {

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });

            let removeAfterUpdate = false;


            areaDiLavoroService.avviaLavorazioneEPendiInCarico(selectedProtocolAreaDiLavoro)
                .then((newSelectedProtocolAreaDiLavoro) => {

                    this.updateProtocolSubmit(newSelectedProtocolAreaDiLavoro, removeAfterUpdate);

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }

    avviaLavorzione = () => {
        let { selectedProtocolAreaDiLavoro } = this.state
        if (selectedProtocolAreaDiLavoro) {


            let removeAfterUpdate = false;


            areaDiLavoroService.avviaLavorazione(selectedProtocolAreaDiLavoro)
                .then((newSelectedProtocolAreaDiLavoro) => {

                    this.updateProtocolSubmit(newSelectedProtocolAreaDiLavoro, removeAfterUpdate);

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }



    onSelectedPriorityChange = (selectedPriority: ProtocolloAreaDiLavoroEF_Priority) => {
        let { selectedProtocolAreaDiLavoro } = this.state
        if (selectedProtocolAreaDiLavoro) {

            this.setState({
                showActionsLoader: true,
            });

            let newSelectedProtocolAreaDiLavoro = { ...selectedProtocolAreaDiLavoro };
            newSelectedProtocolAreaDiLavoro.priorita = selectedPriority;
            let removeAfterUpdate = false;

            areaDiLavoroService.updateProtocolloAreaDiLavoro(newSelectedProtocolAreaDiLavoro)
                .then(() => {

                    this.updateProtocolSubmit(newSelectedProtocolAreaDiLavoro, removeAfterUpdate);

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });
        }
    }

    // Click sul button della commandbar
    onTerminaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi terminare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onTerminaLavorzioneConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onTerminaLavorzioneConfirmDialogSubmit = () => {
        let { selectedProtocolAreaDiLavoro } = this.state
        if (selectedProtocolAreaDiLavoro) {

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });
            let removeAfterUpdate = true;

            areaDiLavoroService.terminaLavorazione(selectedProtocolAreaDiLavoro)
                .then((newSelectedProtocolAreaDiLavoro) => {

                    this.updateProtocolSubmit(newSelectedProtocolAreaDiLavoro, removeAfterUpdate);

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }

    onAggiornaAreaDiLavoroClick = () => {
        let { queryCriteria } = this.state;


        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1 };

        this.setState({
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveState()
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems();

        })

    }

    updateProtocolSubmit = (modifiedItem: IProtocolloAreaDiLavoro, removeAfterUpdate: boolean) => {

        let { items } = this.state;

        let currentItems = items.slice();
        let itemIndex = currentItems.findIndex(el => el?.protocolEFId === this.state.selectedProtocolAreaDiLavoro?.protocolEFId);
        let selectedItem: IProtocolloAreaDiLavoro | undefined = { ...modifiedItem };
        if (removeAfterUpdate) {
            currentItems.splice(itemIndex, 1);
            selectedItem = undefined;
        }
        else {
            currentItems[itemIndex] = modifiedItem;
        }

        this.setState({
            items: currentItems,
            showActionsLoader: false,
            selectedProtocolAreaDiLavoro: selectedItem,
        }, () => {
            this.saveState();
            this.restoreSelection();
            if (removeAfterUpdate) {
                this.updateCommandBarItems();
            }
        });

    }
    // click sul pulsante della command bar
    onEditVisibilitaHandler = () => {

        if (this.props.currentAoo && this.state.selectedProtocolAreaDiLavoro) {
            let { currentAoo } = this.props;
            let { selectedProtocolAreaDiLavoro } = this.state;
            this.setState({
                isLoadingProtocols: true
            })


            protocolsService.getVisibilitaProtocollo(currentAoo.id, selectedProtocolAreaDiLavoro.protocolEF.protocolSpId)
                .then(async result => {

                    let visibilita = [...result];

                    this.setState({
                        isLoadingProtocols: false,
                        confirmDialogIsOpen: true,
                        confirmDialogModalProps: visibilitaModalProps,
                        confirmDialogContentProps: {
                            type: DialogType.largeHeader,
                            title: 'Visibilità',
                            subText: 'Scegli la visibilità.',
                            children:
                                <div style={{ overflow: "hidden", height: "100%", minHeight: "100px" }}>
                                    <Visibilita
                                        visibilita={visibilita}
                                        onUpdateVisibilitaHandler={
                                            (_visibilita) => {
                                                this.setState({ selectedProtocolVisibilita: _visibilita });
                                            }
                                        }
                                        viewMode={Visibilita_ViewMode.Expanded}
                                    />
                                </div>
                        },
                        confirmDialogSubmitFunction: () => { this.submitEditVisibilitaDialog() },
                        selectedProtocolVisibilita: visibilita
                    })

                });

        }
    }

    // Click su conferma del confirm dialog
    submitEditVisibilitaDialog = () => {
        if (this.props.currentAoo && this.props.currentUor && this.state.selectedProtocolAreaDiLavoro) {
            let { currentAoo, currentUor, location } = this.props
            let { selectedProtocolAreaDiLavoro, selectedProtocolVisibilita, items } = this.state;
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({ confirmDialogIsOpen: false, showActionsLoader: true });
            protocolsService.updateVisibilitaProtocol(currentAoo.id, uorId, selectedProtocolAreaDiLavoro.protocolEF.protocolSpId, selectedProtocolVisibilita)
                .then(result => {
                    let selectedItem: IProtocolloAreaDiLavoro | undefined = { ...selectedProtocolAreaDiLavoro };
                    let currentItems = items.slice();
                    let itemIndex = currentItems.findIndex(el => el?.protocolEF.id === selectedProtocolAreaDiLavoro.protocolEFId);
                    let removeItem = selectedProtocolVisibilita.some(el => el.uor.id === currentUor.id && el.tipologia !== Visibility_Type.Visibilita) ? false : true;
                    if (removeItem) {
                        currentItems.splice(itemIndex, 1);
                        selectedItem = undefined;
                    }
                    else {
                        selectedItem!.protocolEF.visibilita = [...selectedProtocolVisibilita];
                        currentItems[itemIndex] = { ...selectedItem };
                    }
                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                        selectedProtocolAreaDiLavoro: selectedItem,
                    }, () => {
                        this.saveState();
                        this.restoreSelection();
                    });

                    toastRef.current?.show({ severity: 'info', summary: 'Aggiornamento', detail: `Visibilità aggiornata correttamente`, life: 5000 });
                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Visibilità non aggiornata`, life: 5000 });
                    }
                });

        }
    }

    //dismissEditVisibilitaDialog = () => {
    //    let currentUor = { ...this.props.currentUor };
    //    let visibilita = [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }];
    //    this.props.setProtocol({ visibilita: visibilita });

    //    this.setState({ confirmDialogIsOpen: false })
    //}
    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    // metodo per paging
    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let { items, queryCriteria } = this.state;

        let currentItems = items.slice();
        currentItems.pop();

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: queryCriteria.pageNumber + 1 };
        this.setState({
            items: currentItems,
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveState();
            this.restoreSelection();
            this.getProtocolliAreaDiLavoro();
        })

        return null;
    };

    // metodo per il render del contenuto delle colonne
    renderItemColumn = (item: (IProtocolloAreaDiLavoro | null), index?: number | undefined, column?: IColumn) => {

        let protocol = item!.protocolEF;
        let stringValue;
        let fontStyle = item?.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere ? { fontWeight: 'bolder', fontStyle: 'italic' } as React.CSSProperties : {};

        if (column) {
            switch (column.key) {
                case 'ProtocolEF.NumeroProtocollo':
                    stringValue = AppUtilities.FormatProtocolNumber(protocol);
                    return <Link id={protocol!.id!.toString()} style={{ ...fontStyle, width: "100%" }} onClick={(ev) => this.onClickProtocol(ev, protocol)} >{stringValue}</Link>;

                case 'ProtocolEF.DataProtocollo':
                    stringValue = AppUtilities.FormatDate(protocol?.dataProtocollo, true);
                    break;

                case 'ProtocolEF.TipoProtocollo':
                    stringValue = protocol === null || protocol === undefined ? undefined : AppUtilities.fixInternalValueForProtocolTypeEnum(protocol.tipoProtocollo);
                    break;

                case 'ProtocolEF.OggettoProtocollo':
                    stringValue = protocol === null || protocol === undefined ? undefined : protocol.oggettoProtocollo;
                    break;

                case 'Priorita':
                    stringValue = item?.priorita ? ProtocolloAreaDiLavoroEF_Priority_Label.get(item?.priorita) : undefined;
                    break;

                case 'PresaInCarico':
                    stringValue = item?.presaInCarico ? item?.presaInCarico.displayName : undefined;
                    break;

                case 'ProtocolEF.Visibilita':
                    return this.renderVisibilitaColumn(item!.protocolEF);

                case 'ProtocolEF.HasAttachments':
                    if (protocol.hasAttachments) {
                        return <Icon iconName="Attach" style={{ fontSize: 16 }} />
                    }
                    stringValue = undefined;
                    break;

                case 'empty':
                    stringValue = undefined;
                    break;
                default:
                    stringValue = "-";
                    break;
            }

            return (
                <TooltipHost
                    content={stringValue}
                    styles={tooltipHostStyles}
                    overflowMode={TooltipOverflowMode.Self}
                >
                    <span style={fontStyle}>{stringValue}</span>
                </TooltipHost>
            );

        }
    }

    renderVisibilitaColumn = (item: IProtocolEF) => {
        if (item.visibilita) {
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number = Number(parsedQueryString.uorId);
            const arrayVisibilita = item.visibilita;
            const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === uorId);
            if (visibilitaObj?.tipologia === Visibility_Type.Proprietario) {
                return (
                    <TooltipHost content="Proprietario">
                        <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'user-tie' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                    </TooltipHost>
                )
            }
            if (visibilitaObj?.tipologia === Visibility_Type.Inoltro) {
                return (
                    <TooltipHost content="Inoltro">
                        <Icon iconName="FastForward" style={{ fontSize: 16, color: palette.themePrimary }} />
                    </TooltipHost>
                )
            }
            if (visibilitaObj?.tipologia === Visibility_Type.Visibilita) {
                return (
                    <TooltipHost content="Visibilità">
                        <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'eye' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                    </TooltipHost>
                )
            }
            if (visibilitaObj?.tipologia === Visibility_Type.CopiaConoscenza) {
                return (
                    <TooltipHost content="Copia Conoscenza">
                        <Icon iconName="Accounts" style={{ fontSize: 16, color: palette.themePrimary }} />
                    </TooltipHost>
                )
            }
        }
        return undefined;
    }

    onClickProtocol = (ev, protocollo: IProtocolEF) => {
        this.avviaLavorzione();
        this.navigate(ev, protocollo);
    }


    navigate = (ev, protocollo: IProtocolEF) => {
        ev?.preventDefault();
        ev?.stopPropagation();

        this.props.setProtocol(protocollo);
        //aggiunge gli zeri prima del numero
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        let { currentAoo, currentUor } = this.props;
        let path;

        if (protocollo && protocollo.id && protocollo.numeroProtocollo) {
            let protocolnumber = zeroPad(protocollo.numeroProtocollo, 8) + '-' + protocollo.annoProtocollo;

            path = `/${currentAoo?.id}/${protocollo.protocolSpId}/${protocolnumber}`;

        }
        this.props.history.push({ pathname: path, search: this.props.location.search });

    }




    // metodi gestione context menu 
    onShowContextualMenu = (item: IProtocolloAreaDiLavoro, index, ev) => {
        ev.preventDefault();

        let protocolloEF = item.protocolEF;
        const menuItems = this.updateContextMenuDashboard(ev, protocolloEF);
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };


    // handlers per panel
    openSearchPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    // Click su cerca del panel laterale
    submitSearchPanel = () => {

        let { searchFormFields, queryCriteria } = this.state;

        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsValueForSearchEFSubmit([...touchedFields]);

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [...fixedFields] };

        this.setState({
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveState()
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems()
        })
    }

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    //metodi per resettare i campi dei filtri
    resetSearchHandler = () => {
        let { searchFormFields, queryCriteria } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [] };

        this.protocolSelection.setAllSelected(false);

        this.setState({
            searchFormFields: newSearchFields,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveState()
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems();

        })

    }
    resetSearchFieldsHandler = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields
        }, () => {
            this.saveState()
        });
    }





    //metodo per il render nei campi dei filtri
    formSearchInputChangedHandler = (newField: IField) => {
        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        }, () => {
            this.saveState()
        });

    }


    //metodo per il render dei bottoni nel panel
    onRenderSearchPanelFooter = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.submitSearchPanel}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFieldsHandler()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }



    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }


    render() {
        let loaderClass = this.state.showActionsLoader ? "active" : '';

        return (
            <React.Fragment>
                <div className="workspace-component">
                    <div className={"loader opacity " + loaderClass}>
                        <RippleLoader text='Operazione in corso' />
                    </div>

                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={this.state.commandBarItems}
                        styles={commandBarStyles}

                    />

                    <div className={classNames.filtriCommandBar} >
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.filtriCommandBarItems}
                            styles={filtriCommandBarStyles}

                        />
                    </div>


                    {this.state.items.length > 0 &&

                        <DetailsList
                            className="with-empty-column"
                            styles={detailsListStyles}
                            componentRef={this.detailsListRef}
                            items={this.state.items}
                            columns={this.state.columns}
                            onColumnHeaderClick={this.onColumnHeaderClick}
                            onRenderItemColumn={this.renderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            onRenderMissingItem={this.onRenderMissingItem}
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this.protocolSelection}
                            selectionPreservedOnEmptyClick={true}
                            selectionMode={SelectionMode.single}
                            checkboxVisibility={CheckboxVisibility.onHover}
                            onItemContextMenu={this.onShowContextualMenu}

                        />

                    }
                    {this.state.items.length === 0 &&

                        <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                    }

                    <Dialog
                        hidden={!this.state.confirmDialogIsOpen}
                        onDismiss={this.dismissConfirmDialog}
                        dialogContentProps={this.state.confirmDialogContentProps}
                        modalProps={this.state.confirmDialogModalProps}
                    >
                        {this.state.confirmDialogContentProps.children &&
                            this.state.confirmDialogContentProps.children
                        }


                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                        </DialogFooter>

                    </Dialog>

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />

                    <Panel
                        isLightDismiss
                        isOpen={this.state.searchPanelIsOpen}
                        type={PanelType.custom}
                        customWidth={'600px'}
                        headerText={'Filtri di ricerca'}

                        onDismiss={this.dismissSearchPanel}
                        onRenderFooterContent={this.onRenderSearchPanelFooter}

                        closeButtonAriaLabel="Close"
                        isHiddenOnDismiss={false}
                    >
                        {this.state.messageBarIsVisible &&
                            <MessageBar
                                messageBarType={this.state.messageBarType}
                                isMultiline={false}
                                onDismiss={this.dismissMessageBar}
                                dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                        }


                        <div className={`search-form-dialog flex flex-column position-relative`}>

                            <div className={`position-relative my-scroll-div`}>
                                <div >
                                    <DynamicForm
                                        fields={this.state.searchFormFields}
                                        onInputChangedHandler={(newField) => { this.formSearchInputChangedHandler(newField) }}
                                    />

                                </div>

                            </div>

                        </div>
                    </Panel>


                </div>
            </React.Fragment>
        );
    }


}
export default connector(withRouter(AreaDiLavoro));
